// extracted by mini-css-extract-plugin
module.exports = {"subheading":"subheading--a16dc"};